import { differenceInDays } from "date-fns";

interface PopupStorageInformation {
  lastShownTime?: number;
  lastOpenedChatTime?: number;
}
const POPUP_DETAILS_KEY = "radioombun-popup-v3";
export const checkStartupPopup = () => {
  const daysIntervalToCheck = 14;
  const checkIfDateInterval = (dateTime: number) =>
    Math.abs(differenceInDays(new Date(dateTime), new Date())) < daysIntervalToCheck;
  const { lastShownTime, lastOpenedChatTime } = JSON.parse(
    localStorage.getItem(POPUP_DETAILS_KEY) || "{}"
  ) as PopupStorageInformation;

  // if never shown, show now
  if (!lastShownTime) {
    return true;
  }

  // if opened chat in interval, don't show
  if (lastOpenedChatTime && checkIfDateInterval(lastOpenedChatTime)) {
    return false;
  }

  // if popup shown in 2 weeks, don't show
  if (checkIfDateInterval(lastShownTime)) {
    return false;
  }

  return true;
};

export const savePopupLastShownTime = () => {
  const popupStorageInformation = JSON.parse(
    localStorage.getItem(POPUP_DETAILS_KEY) || "{}"
  ) as PopupStorageInformation;
  popupStorageInformation.lastShownTime = new Date().getTime();
  localStorage.setItem(POPUP_DETAILS_KEY, JSON.stringify(popupStorageInformation));
};
export const saveChatLastOpenedTime = () => {
  const popupStorageInformation = JSON.parse(
    localStorage.getItem(POPUP_DETAILS_KEY) || "{}"
  ) as PopupStorageInformation;
  popupStorageInformation.lastOpenedChatTime = new Date().getTime();
  localStorage.setItem(POPUP_DETAILS_KEY, JSON.stringify(popupStorageInformation));
};
